// extracted by mini-css-extract-plugin
export default {"sortIcon":"TableChartSortIcon_sortIcon__fio1n","sortIconAsc":"TableChartSortIcon_sortIconAsc__0-lEH","sortIconDesc":"TableChartSortIcon_sortIconDesc__p2SpI"};